import { hasSeatSelection } from 'utils/Reserbus';
import wayIsOpenTicket from '../wayIsOpenTicket';
import tripSupportsSeatSelection from './tripSupportsSeatSelection';
import { hasOversoldSeats } from '../overbooking';

export default (purchase) => {
  const { departs, returns, roundTrip, preSelectedSeats } = purchase;

  const departsAllowsSeatSelection =
    hasSeatSelection(departs) &&
    !wayIsOpenTicket(departs) &&
    tripSupportsSeatSelection(departs) &&
    !hasOversoldSeats(preSelectedSeats?.departure);

  if (!roundTrip) {
    return departsAllowsSeatSelection;
  }

  const returnsAllowsSeatSelection =
    hasSeatSelection(returns) &&
    !wayIsOpenTicket(returns) &&
    tripSupportsSeatSelection(returns) &&
    !hasOversoldSeats(preSelectedSeats?.return);

  return departsAllowsSeatSelection || returnsAllowsSeatSelection;
};
